module.exports = __webpack_public_path__ + "media/images/flags/4x3/cat-208ddf7aca91a5fbfa2b21b7f0af7366.svg";